import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { getFeatureToggle } from '@capital-access/common/feature-toggle';
import { NavConfig, NavConfigFn, NavigationConfigProvider } from '@capital-access/common/navigation';
import { ADV_SEARCH_FEATURE_TOGGLE, ADV_SEARCH_PATH } from './constants';

@Injectable()
export class AdvSearchNavConfigProvider implements NavigationConfigProvider {
  constructor(private store: Store) {}

  resolveNavConfig: NavConfigFn = () => {
    return this.store.select(getFeatureToggle(ADV_SEARCH_FEATURE_TOGGLE)).pipe(
      map(isEnabled => {
        return <NavConfig>{
          top: [
            {
              localizationKey: 'adv-search',
              icon: 'f-i-stars-outlined',
              order: 80,
              link: ADV_SEARCH_PATH,
              enabled: isEnabled
            }
          ]
        };
      })
    );
  };
}
